exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1MdnW{padding-left:0;padding-right:0;background-color:rgba(198,206,208,.1);min-height:70vh;-ms-flex:1 1 0%;flex:1 1 0%}._1fNdN{margin:0 auto;padding:0 0 40px;max-width:100%;margin-top:1px}.Ap5ru{max-width:912px;width:100%;display:block;margin:0 auto}._2DyPP{font-size:24px;color:#484848;margin:0 0 18px}.qvhvt{margin-top:60px;margin-bottom:100px}._3NxeY{font-size:32px;color:#484848;margin:0 0 30px}._2OdjH{font-size:14px;color:#bbb;font-weight:700;text-transform:uppercase;margin:0 0 6px;display:block}", ""]);

// exports
exports.locals = {
	"root": "_1MdnW",
	"container": "_1fNdN",
	"landingContainer": "Ap5ru",
	"landingContentTitle": "_2DyPP",
	"landingContent": "qvhvt",
	"landingTitle": "_3NxeY",
	"landingStep": "_2OdjH"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/becomeHost/BecomeHost.css
// module id = 2613
// module chunks = 15